import axios from "axios";
import {ContactSearchRow} from "@/api/contacts";

export enum ContactRelationType {
    RESELLER = "RESELLER",
    RESELLER_CUSTOMER = "RESELLER_CUSTOMER",
    PARENTS = "PARENTS",
    CHILD = "CHILD",
    COUPLE = "COUPLE",
    EMPLOYER = "EMPLOYER",
    EMPLOYEE = "EMPLOYEE",
    DONOR = "DONOR",
}

export enum MigrationType {
    CONTACT_PERSON = "CONTACT_PERSON",
    EXTERNAL_CONTACT_PERSON = "EXTERNAL_CONTACT_PERSON",
}

export interface ContactRelationResult {
    id: string | null;
    relationType: ContactRelationType;
    withContact: ContactSearchRow;
    active: boolean;
}

export interface AddContactRelationRequest {
    relationType: ContactRelationType;
    withContactRef: string;
    syncExistingEncounters: boolean;
}

interface ContactRelationApi {
    list(contactId: string): Promise<ContactRelationResult[]>;

    count(contactId: string): Promise<number>;

    listResellerCustomers(contactId: string): Promise<ContactRelationResult[]>;

    add(
        contactId: string,
        addContactRelationRequest: AddContactRelationRequest
    ): Promise<string>;

    delete(contactId: string, id: string): Promise<void>;

    deactivate(contactId: string, id: string): Promise<void>;

    activate(contactId: string, id: string): Promise<void>;

    migrateRelation(contactId: string, id: string, migrationType: MigrationType): Promise<void>;
}

export const contactRelationApi: ContactRelationApi = {
    async list(contactId) {
        if (!contactId || contactId.length === 0) {
            return [];
        }
        const result = (
            await axios.get(`/api/contacts/${contactId}/contact-relations`)
        ).data as ContactRelationResult[];
        if (result) {
            return result.map(
                (v) =>
                    ({
                        ...v,
                    } as ContactRelationResult)
            );
        }
        return [];
    },
    async listResellerCustomers(contactId) {
        const result = (
            await axios.get(
                `/api/contacts/${contactId}/contact-relations/reseller-customer`
            )
        ).data as ContactRelationResult[];
        if (result) {
            return result.map(
                (v) =>
                    ({
                        ...v,
                    } as ContactRelationResult)
            );
        }
        return [];
    },

    async count(contactId) {
        return (await axios.get(
            `/api/contacts/${contactId}/contact-relations/count`
        )).data
    },
    async add(contactId, addContactRelationRequest) {
        return (
            await axios.post(
                `/api/contacts/${contactId}/contact-relations`,
                addContactRelationRequest
            )
        ).data;
    },

    async delete(contactId, id) {
        return await axios.delete(
            `/api/contacts/${contactId}/contact-relations/${id}`
        );
    },

    async deactivate(contactId, id) {
        return await axios.put(
            `/api/contacts/${contactId}/contact-relations/${id}/deactivate`
        );
    },

    async activate(contactId, id) {
        return await axios.put(
            `/api/contacts/${contactId}/contact-relations/${id}/activate`
        );
    },

    async migrateRelation(contactId, id, migrationType) {
        return await axios.put(
            `/api/contacts/${contactId}/contact-relations/${id}/migrate?migrationType=${migrationType}`
        );
    },
};
